import { JsonObject, JsonProperty } from 'json2typescript';

import { AbstractEntity } from '../abstract-entity/abstract-entity';
import { Avatar } from './avatar';
import { Sex } from './sex.enum';

/**
 * ä¸ªäººä¿¡æ¯
 */
@JsonObject
export class Me extends AbstractEntity {
  /**
   * è´¦å·Id(è´¦å·Id(accountId)åç¨æ·Id(userId)å¹¶ä¸ä¸è´)
   */
  @JsonProperty('accountId', Number)
  accountId: number = undefined;

  /**
   * å¤´å
   */
  @JsonProperty('avatar', Avatar)
  avatar: Avatar = undefined;

  /**
   * ææºå·
   */
  @JsonProperty('phoneNum', String)
  phoneNum: string = undefined;

  /**
   * æ­£å¼å§å
   */
  @JsonProperty('realName', String)
  realName: string = undefined;

  /**
   * æ§å«
   */
  @JsonProperty('sex', String)
  sex: Sex = undefined;

  /**
   * å¼å§å·¥ä½æ¶é´(æ¶é´æ³)
   */
  @JsonProperty('startWorkTime', Number)
  startWorkTime: number = undefined;

  /**
   * èº«ä»½è¯id
   */
  @JsonProperty('idCard', String)
  idCard: string = undefined;
}
